module.exports = __webpack_public_path__ + "static/media/batches.537f0e77.png";